import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { toastr } from 'react-redux-toastr';
import DataTable from '../tables/DataTable';
import withTable from '../tables/withTable';
import {
  loadAddWatchList,
  loadBidHistory,
  loadEventInfo,
  loadItem,
  loadRemoveWatchList,
  loadRunListES,
  loadWatchlistObject,
  resetBidHistory,
  resetEventInfo,
  resetItem,
  resetRunlistES,
} from '../../actions';
import { getConfig, compose, showOfferButton } from '../../utils/helpers';
import { Button, Icon } from 'semantic-ui-react';
import styles from './styles';
import OfferModal from '../OfferModal';

class RunListEvent extends Component {
  constructor(props) {
    super(props);
    const mpId = getConfig('marketplaceId');
    
    this.state = {
      isOfferModalOpen: false,
      loading: null,
      mpId,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.params.eventId !== prevProps.params.eventId) {
      this.loadData();
    }

    if (this.state.loading && this.props.runListES.hits && !prevProps.runListES.hits) {
      this.setState({ loading: false });
    }
  }

  componentWillUnmount() {
    this.props.resetEventInfo();
  }

  loadData = () => {
    const { params, listingStatusIds, authorizedEventIds } = this.props;
    const { eventId } = params;
    const mpId = getConfig('marketplaceId');

    this.setState({ loading: true }, () => {
      this.props.resetEventInfo();
      this.props.resetRunlistES();
      this.props.loadEventInfo(mpId, eventId);
      this.props.loadRunListES(
        listingStatusIds,
        null,
        authorizedEventIds,
        eventId
      );
    });
  };

  handleWatchlistClick = (itemId, isInWatchlist) => {
    const mpId = getConfig('marketplaceId');
    const watchlistAction = isInWatchlist
      ? this.props.loadRemoveWatchList
      : this.props.loadAddWatchList;

    const message = isInWatchlist
      ? 'Removed from your watchlist'
      : 'Added to your watchlist';

    watchlistAction(mpId, itemId).then(({ response }) => {
      if (response.wsStatus === 'Success') {
        this.props.loadWatchlistObject(mpId);
        toastr.success('Success', message, { timeOut: 2000 });
      }
    });
  };

  handleDetailsClick = (itemId, data) => {
    const path = `/item/${itemId}`;
    this.props.navigate(path);
    const ids = (data || [])
      .map(item => item._id || item.id || item.itemId)
      .join(',');
    sessionStorage.setItem('navItems', ids);
  };

  handleOfferClick = (itemId) => {
    const {mpId} = this.state;
    this.props.resetItem();
    this.props.resetBidHistory();
    this.props.loadItem(mpId, itemId);
    this.props.loadBidHistory(mpId, itemId)
      .then(bidHistoryRes => {
        this.setState({ isOfferModalOpen: true });
      }).catch(err => console.error(err));
  }

  makeActionButtons = (data) => {
    return {
      Header: 'Actions',
      id: 'buttons',
      headerStyle: { background: 'none' },
      sortable: false,
      filterable: false,
      Cell: row => {
        const itemId = row.original.itemId || row.original.id;
        const isInWatchlist = this.props.watchlistObject[itemId];
        const displayOfferButton = showOfferButton(row.original);

        return (
          <div style={styles.buttonGroup}>
            {/* Place Offer */}
            {displayOfferButton 
              ? (<Button style={styles.button} onClick={() => this.handleOfferClick(itemId)}>Place Offer</Button>) 
              : null
            }
            {/* VDP Link */}
            <Button
              style={styles.button}
              onClick={() => this.handleDetailsClick(itemId, data)}
            >
              View Details
            </Button>
            {/* Watchlist */}
            <Button
              style={styles.button}
              onClick={() =>
                this.handleWatchlistClick(itemId, isInWatchlist)
              }
            >
              <Icon name={isInWatchlist ? `check` : `add`} />
              {`Watchlist`}
            </Button>
          </div>
        );
      },
    }
  }

  makeColumns(data) {
    const hideQRCode = (this.props.marketplaceFeatures.features || '')
      .split(',')
      .includes('534');

    const columns = this.props.makeColumns(
      [
        'checkbox',
        'image',
        this.makeActionButtons(data),
        'vin',
        'year',
        'make',
        'model',
        'stockNumber',
        'mileage',
        'extColor',
        'engine',
        'transmission',
        'grade',
        'sellerName',
        'lotNumber',
        hideQRCode ? null : 'qrCode',
        'vehicleAddress',
        'vehicleCity',
        'vehicleState',
        'vehicleZip',
      ].filter(item => item)
    );

    return columns;
  }

  renderOfferModal() {
    try {
      const {item={}} = this.props;
      const crData = {
        crLink: item.cr?.crLink,
        crType: item.cr?.type,
      }

      return (
        <OfferModal
          crData={crData}
          isOpen={this.state.isOfferModalOpen}
          item={item.item}
          loadData={this.loadData}
          modalId={'Run List - No Sales'}
          navigate={this.props.navigate}
          offerAmount={0}
          offerId={0}
          offerType={"Offer"}
          onClose={() => {
            this.setState(
              {isOfferModalOpen: false}, 
              () => {
                this.props.resetBidHistory();
                this.props.resetItem();
              })
          }}
          requiredAmount={0}
          user={this.props.userProfile.user}
        />
      );

    } catch (renderOfferModalError) {
      console.error("Error rendering OfferModal", renderOfferModalError?.message || renderOfferModalError);
      toastr.error("Error", "An issue occurred loading Offer information, please try again or contact support.");
    }
  }

  render() {
    const { runListES, eventInfo, selectedData } = this.props;
    const { loading } = this.state;

    const data = runListES.hits?.hits;
    const noResults = !loading && (!data || !data.length);
    const title = eventInfo.eventInfo
      ? `Run List - ${eventInfo.eventInfo.name}`
      : `Run List Event`;

    return (
      <div
        className="st-container shadow padding background-white padding"
        style={styles.container}
      >
        {this.renderOfferModal()}
        <div style={styles.title}>
          <h4>{title}</h4>
        </div>

        {loading === null ? null : loading ? (
          <div style={styles.message}>Loading...</div>
        ) : noResults ? (
          <div style={styles.message}>
            There are currently no items in this event
          </div>
        ) : (
          <DataTable
            loading={loading}
            title={title}
            data={data.map(item => item._source)}
            selectedData={selectedData}
            columns={this.makeColumns(data)}
            showCSVButton={true}
            showPrintButton={true}
            showWatchlistButton={true}
          />
        )}
      </div>
    );
  }
}

RunListEvent.propTypes = {
  eventInfo: PropTypes.object.isRequired,
  loadEventInfo: PropTypes.func.isRequired,
  loadRunListES: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  const {
    eventInfo,
    item,
    listingStatusIds,
    runListES,
    authorizedEventIds,
    userProfile,
    watchlistObject,
    watchlistUserItems,
  } = state.entities;
  return {
    eventInfo,
    item,
    listingStatusIds,
    runListES,
    authorizedEventIds,
    userProfile,
    watchlistObject,
    watchlistUserItems,
  };
};

export default compose(
  withTable,
  connect(mapStateToProps, {
    loadAddWatchList,
    loadBidHistory,
    loadEventInfo,
    loadItem,
    loadRemoveWatchList,
    loadRunListES,
    loadWatchlistObject,
    resetBidHistory,
    resetEventInfo,
    resetItem,
    resetRunlistES,
  })
)(RunListEvent);
